/**
 * FiltersBar Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityTransitionGroup } from 'velocity-react';

import FilterList from '../FilterList';

interface IOwnProps {
  totalResults?: number;
  className?: string;
}

type FilterBarProps = IOwnProps;

interface IOwnState {
  searchInput: string;
}

const classes = new BEM('filter-bar');

export default class FilterBar extends React.Component<FilterBarProps, IOwnState> {

  constructor(props: FilterBarProps) {
    super(props);

    this.state = {
      searchInput: '',
    };
  }

  render() {
    const classModifiers = {
      normal: true,
    };

    return (
      <VelocityTransitionGroup
        enter={{ animation: 'transition.fadeIn', display: 'flex', delay: 500 }}
        leave={{ animation: 'transition.fadeOut' }}
        {...classes('', classModifiers, this.props.className) }
      >
        <FilterList />
      </VelocityTransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/FilterBar/index.tsx